import multilangMessages from "config/locales/multilang.json";

export const getMultilangMessage = messageKey => multilangMessages[messageKey];
